<section class="toasts" [attr.aria-label]="'SHELL_NOTIFICATIONS' | translate">
  @for (toast of store.toasts(); track toast.id) {
    <article
      class="toast"
      [class]="'toast is-' + toast.severity"
      [attr.role]="toast.severity === severities.Error ? 'alert' : 'status'"
      [attr.aria-live]="
        toast.severity === severities.Error ? 'assertive' : 'polite'
      "
      (mouseenter)="store.pause(toast.id)"
      (mouseleave)="store.resume(toast.id)"
      (focusin)="store.pause(toast.id)"
      (focusout)="store.resume(toast.id)"
    >
      <mat-icon class="toast__icon" aria-hidden="true">{{
        icon(toast.severity)
      }}</mat-icon>

      <div class="toast__body">
        @if (toast.title) {
          <p class="toast__title">
            {{ toast.title | translate: toast.params }}
            @if (toast.count > 1) {
              <span class="toast__count">×{{ toast.count }}</span>
            }
          </p>
        }
        <p class="toast__message">
          {{ toast.message | translate: toast.params }}
        </p>
        @if (toast.detail) {
          <div class="toast__detail">
            @if (toast.severity === severities.Error) {
              <span class="toast__detail-label">{{
                "SHELL_NOTIFICATION_REASON" | translate
              }}</span>
            }
            <p class="toast__detail-text">{{ toast.detail }}</p>
          </div>
        }
        @if (toast.where?.length) {
          <p class="toast__where">
            <mat-icon aria-hidden="true">place</mat-icon>
            <span>{{ toast.where!.join(" › ") }}</span>
          </p>
        }
      </div>

      <div class="toast__actions">
        @if (
          toast.severity === severities.Error &&
          (toast.detail || toast.where?.length)
        ) {
          <button
            mat-icon-button
            type="button"
            class="toast__action"
            [attr.aria-label]="'SHELL_COPY_DETAILS' | translate"
            [matTooltip]="
              (copiedId() === toast.id ? 'SHELL_COPIED' : 'SHELL_COPY_DETAILS')
                | translate
            "
            (click)="copy(toast)"
          >
            <mat-icon>{{
              copiedId() === toast.id ? "check" : "content_copy"
            }}</mat-icon>
          </button>
        }
        <button
          mat-icon-button
          type="button"
          class="toast__action"
          [attr.aria-label]="'SHELL_DISMISS' | translate"
          (click)="store.dismiss(toast.id)"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      @if (toast.severity !== severities.Error) {
        <!-- Restarted by the track key's count so a repeat refills it. -->
        @for (tick of [toast.count]; track tick) {
          <span
            class="toast__timer"
            aria-hidden="true"
            [style.animation-duration.ms]="duration"
          ></span>
        }
      }
    </article>
  }
</section>
